import { render, staticRenderFns } from "./FundWalletModal.vue?vue&type=template&id=3fb24098&scoped=true&"
import script from "./FundWalletModal.vue?vue&type=script&lang=js&"
export * from "./FundWalletModal.vue?vue&type=script&lang=js&"
import style0 from "./FundWalletModal.vue?vue&type=style&index=0&id=3fb24098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb24098",
  null
  
)

export default component.exports